const SAFE_PROTOCOLS = new Set(["http:", "https:"])

export const assertSafeReturnUrl = (returnUrl: string | undefined, baseUrl: string): string => {
  const raw = returnUrl || baseUrl
  let parsed: URL
  let base: URL

  try {
    parsed = new URL(raw, baseUrl)
    base = new URL(baseUrl)
  } catch {
    throw new Error("Unable to parse returnUrl")
  }

  if (!SAFE_PROTOCOLS.has(parsed.protocol)) {
    throw new Error("Unsupported returnUrl protocol")
  }

  if (parsed.username || parsed.password) {
    throw new Error("Return URL must not contain credentials")
  }

  if (!isAllowedReturnHost(parsed.hostname, base.hostname)) {
    throw new Error("Return URL host is not allowed")
  }

  return parsed.href
}

export const isAllowedReturnHost = (hostname: string, currentHostname?: string): boolean => {
  const normalized = hostname.toLowerCase()
  const current = currentHostname?.toLowerCase()

  return (
    normalized === "metal.com" ||
    normalized.endsWith(".metal.com") ||
    normalized === "localhost" ||
    normalized === "127.0.0.1" ||
    (!!current && normalized === current)
  )
}

export const buildLoginRedirectUrl = (
  userCenterUrl: string,
  locale: string,
  action: string,
  returnUrl: string
): string => {
  const url = new URL(`/${locale}/login`, userCenterUrl)
  url.searchParams.set("action", action)
  url.searchParams.set("url", returnUrl)
  return url.href
}
